import { AxiosError } from 'axios';
import { classifyFailure, isAuthShapedFailure } from 'services/session';

/**
 * What a failed boot request should do to the session.
 *
 * - `sign-out` — report-only mode, and the failure looks like a rejected token:
 *   sign out as the app always has.
 * - `defer`    — enforcement is on: the session monitor probes Core and the
 *   SessionExpirationGuard performs the one sign-out if the token is dead.
 * - `stay`     — the failure says nothing about the session (Core down, 5xx,
 *   network, a bug): keep the user signed in.
 */
export type BootstrapFailureDecision = 'sign-out' | 'defer' | 'stay';

export const decideBootstrapFailure = (
  error: unknown,
  enforcing: boolean
): BootstrapFailureDecision => {
  if (!isAuthShapedFailure(error)) {
    return 'stay';
  }
  return enforcing ? 'defer' : 'sign-out';
};

/** Safe to log: never the URL, the body or the token the error carries. */
export const describeFailure = (error: unknown) => {
  const { status, host } = classifyFailure(error as AxiosError);
  return { status, host };
};
